import React from "react";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import Button from "@components/Button/Button";
import Subheader from "@components/Subheader/Subheader";
import PageLayout from "@layouts/PageLayout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VesselNominationGrid from "./grid/VesselNominationGrid";
import { canRequestVesselNomination } from "./vessel-scan/nominationTypeOptions";

export const LANG_BASE = "vessel-nomination";
const TEST_ID_BASE = "vessel-nomination-page";

const VesselNominationContainer: React.FC = () => {
  const navigate = useNavigate();
  const { userActionPermissions } = useAuthStore();

  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId={`${TEST_ID_BASE}-subheader`}
        subtitle={t("navigation.vessel-nomination")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{t(`${LANG_BASE}.title`)}</span>
            {canRequestVesselNomination(userActionPermissions) && (
              <Button
                type="button"
                variant="contained"
                color="primary"
                label={t(`${LANG_BASE}.addVesselNomination`)}
                testId={`${TEST_ID_BASE}-add-vessel-nomination-button`}
                sx={{ height: "40px", minHeight: "40px", textTransform: "none" }}
                onClick={() => navigate("/vessel-nomination/vessel-scan")}
                startIcon={<ControlPointIcon />}
              />
            )}
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6">
        <VesselNominationGrid />
      </div>
    </PageLayout>
  );
};

export default VesselNominationContainer;
